import { H1 } from "../components/h1";
import { Layout } from "../components/layout";
import { PasswordForm } from "../components/profile/password-form";
import { useLocale } from "../stores/locale";

export function Profile() {
  const t = useLocale((state) => state.locale);

  return (
    <Layout>
      <div className="mt-10 mx-auto lg:w-8/12 xl:w-6/12">
        <H1 className="text-3xl mb-5">{t.profile.title}</H1>
        <PasswordForm />
      </div>
    </Layout>
  );
}
